export const GOOGLE_CLIENT_ID =
  '135984415621-ek29i15klcd6mvpr8pfn1dke7j44qe4u.apps.googleusercontent.com'

export const FACEBOOK_APP_ID = '1748255805392835'

export const GOOGLE_MAPS_KEY = 'AIzaSyCmqfvXCqufprEUeQBz7Bl0lekVbRzDGFU'

export const INSTAGRAM_CLIENT_ID = '7b17e3befd1048c695bbbcb96cedef90'
